import { render, staticRenderFns } from "./AddSchoolDialog.vue?vue&type=template&id=9aef77f4&"
import script from "./AddSchoolDialog.ts?vue&type=script&lang=ts&"
export * from "./AddSchoolDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports